import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityEducation = () => {
  const benefits = [
    {
      icon: 'Shield',
      title: 'Enhanced Security',
      description: 'Adds an extra layer of protection beyond just your password'
    },
    {
      icon: 'Lock',
      title: 'Account Protection',
      description: 'Prevents unauthorized access even if your password is compromised'
    },
    {
      icon: 'CheckCircle',
      title: 'Peace of Mind',
      description: 'Know that your account and personal data are secure'
    }
  ];

  const bestPractices = [
    'Use an authenticator app instead of SMS when possible',
    'Keep backup codes in a secure, offline location',
    'Never share your 2FA codes with anyone',
    'Update your phone number if it changes',
    'Test your 2FA setup after configuration'
  ];

  const recoverySteps = [
    'Try using a backup code from your saved list',
    'Use SMS backup if you configured it',
    'Contact support with proof of identity',
    'Account recovery may take 24-48 hours'
  ];

  return (
    <div className="space-y-6">
      {/* Why 2FA */}
      <div className="card">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Info" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Why Use 2FA?</h3>
        </div>
        <div className="space-y-4">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={benefit?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{benefit?.title}</p>
                <p className="text-xs text-muted-foreground mt-1">{benefit?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Best Practices */}
      <div className="card">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="CheckCircle" size={20} className="text-success" />
          <h3 className="text-lg font-semibold text-foreground">Best Practices</h3>
        </div>
        <ul className="space-y-2">
          {bestPractices?.map((practice, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
              <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
              <span>{practice}</span>
            </li>
          ))}
        </ul>
      </div>
      {/* Recovery Procedures */}
      <div className="card">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="LifeBuoy" size={20} className="text-warning" />
          <h3 className="text-lg font-semibold text-foreground">Lost Access?</h3>
        </div>
        <p className="text-sm text-muted-foreground mb-3">
          If you lose access to your 2FA device:
        </p>
        <ol className="space-y-2">
          {recoverySteps?.map((step, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
              <span className="text-warning font-medium flex-shrink-0">{index + 1}.</span>
              <span>{step}</span>
            </li>
          ))}
        </ol>
      </div>
      {/* Security Level Indicator */}
      <div className="card bg-gradient-to-br from-success/10 to-primary/10 border-success/20">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-success/20 flex items-center justify-center">
            <Icon name="Shield" size={20} className="text-success" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">Security Level</p>
            <p className="text-xs text-muted-foreground">After 2FA Setup</p>
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Account Protection</span>
            <span className="text-success font-medium">High</span>
          </div>
          <div className="w-full bg-muted/30 rounded-full h-2">
            <div className="bg-success h-2 rounded-full" style={{ width: '90%' }} />
          </div>
        </div>
      </div>
      {/* Support Contact */}
      <div className="card bg-muted/30">
        <div className="flex items-start gap-3">
          <Icon name="HelpCircle" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">Need Help?</p>
            <p className="text-xs text-muted-foreground mb-2">
              Contact our support team if you have questions about 2FA setup.
            </p>
            <a
              href="mailto:support@trainarygym.com"
              className="text-xs text-primary hover:underline"
            >
              support@trainarygym.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityEducation;